module.exports = __webpack_public_path__ + "static/media/motoG.862836fe.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/pricing/motoG.png
 ** module id = 650
 ** module chunks = 0
 **/